import { render, staticRenderFns } from "./Bando29Fase8.vue?vue&type=template&id=e4ba41a2&scoped=true"
import script from "./Bando29Fase8.vue?vue&type=script&lang=js"
export * from "./Bando29Fase8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ba41a2",
  null
  
)

export default component.exports